(function () {
  'use strict';

  var root = document.getElementById('zoqOffer');
  if (!root || root.getAttribute('data-zo-ready')) return;
  root.setAttribute('data-zo-ready', '1');

  var CONFIG = {
    delayMs: 20000,          // time on the page before the popup may appear
    exitIntent: true,        // desktop only: pointer leaves through the top edge
    exitMinDwellMs: 5000,    // ignore exit intent during the first few seconds
    dismissHoldHours: 24,    // stay away after "Maybe later" / close
    claimHoldHours: 72,      // stay away after an offer is claimed
    careKitHandle: 'premium-leather-care-kit',
    careKitBarcode: '810012345678',
    careKitVariantId: 51756134531362,
    cartUrl: (window.Shopify && window.Shopify.routes && window.Shopify.routes.root || '/') + 'cart'
  };

  var HOLD_KEY = 'zoq_offer_hold_until';
  var BUSY = '.js-drawer-open, .drawer--is-open, .modal--is-active, .modal-open, .bespoke-modal.is-open, .zoq-pp-drawer.is-open, .pswp--open, dialog[open], theme-drawer[open], .zoq-bespoke.is-open';

  var store = {
    get: function (k) { try { return window.localStorage.getItem(k); } catch (e) { return null; } },
    set: function (k, v) { try { window.localStorage.setItem(k, v); } catch (e) { /* storage blocked */ } },
    del: function (k) { try { window.localStorage.removeItem(k); } catch (e) { /* storage blocked */ } }
  };

  var routeRoot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var text = JSON.parse(root.querySelector('[data-zo-messages]').textContent);
  function $(sel) { return root.querySelector(sel); }
  function message(key) { return text[key] || ''; }
  function request(path, data) {
    var controller = new AbortController();
    var timeout = window.setTimeout(function () { controller.abort(); }, 12000);
    return window.fetch(routeRoot + path, {
      method: data ? 'POST' : 'GET', credentials: 'same-origin', signal: controller.signal,
      headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
      body: data ? JSON.stringify(data) : undefined
    }).then(function (response) {
      if (!response.ok) throw new Error('request_failed');
      return response.json();
    }).finally(function () { window.clearTimeout(timeout); });
  }
  var dialog = $('.zoq-offer__dialog');
  var radios = root.querySelectorAll('input[name="zoq-offer"]');
  var claimBtn = $('[data-zo-claim]');
  var ctaLabel = $('[data-zo-cta-label]');
  var codeEl = $('[data-zo-code]');
  var copyBtn = $('[data-zo-copy]');
  var copyLabel = $('[data-zo-copy-label]');
  var statusEl = $('[data-zo-status]');
  var bagEl = $('[data-zo-bag]');
  var errorEl = $('[data-zo-error]');
  var noteEl = $('[data-zo-note]');

  var state = {
    open: false, shown: false, armed: false, claiming: false, opening: null, refreshing: null, refreshAgain: false,
    lastFocus: null, cart: null, swapTimer: null, copyTimer: null, cleanup: null, token: 0
  };

  function reduced() {
    return !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  }
  function pageEl() { return document.querySelector('.page-wrapper'); }

  /* ---------------------------------------------------------------- selection */
  function current() {
    for (var i = 0; i < radios.length; i++) { if (radios[i].checked) return radios[i]; }
    return radios[0];
  }
  function currentCode() { return current().value; }

  function setCta(text, animate) {
    window.clearTimeout(state.swapTimer);
    if (!animate || reduced()) {
      ctaLabel.textContent = text;
      ctaLabel.classList.remove('is-swap');
      return;
    }
    ctaLabel.classList.add('is-swap');
    state.swapTimer = window.setTimeout(function () {
      ctaLabel.textContent = text;
      ctaLabel.classList.remove('is-swap');
    }, 170);
  }
  function resetCopy() {
    window.clearTimeout(state.copyTimer);
    copyBtn.classList.remove('is-done');
    copyLabel.textContent = 'Copy';
  }
  function syncSelection(animate) {
    var r = current();
    codeEl.textContent = r.value === 'ZPRIO' ? message('no_code') : r.value;
    copyBtn.disabled = r.value === 'ZPRIO';
    noteEl.textContent = r.value === 'ZSHIP' ? message('shipping_note') : message('exclusive_note');
    errorEl.hidden = true;
    setCta(r.getAttribute('data-cta') || 'Claim offer', animate);
    resetCopy();
  }
  Array.prototype.forEach.call(radios, function (r) {
    r.addEventListener('change', function () { syncSelection(true); });
  });

  /* ---------------------------------------------------------------- copy */
  function legacyCopy(text) {
    var ta = document.createElement('textarea');
    ta.value = text;
    ta.setAttribute('readonly', '');
    ta.style.cssText = 'position:fixed;top:0;left:0;opacity:0;pointer-events:none';
    document.body.appendChild(ta);
    ta.select();
    var ok = false;
    try { ok = document.execCommand('copy'); } catch (e) { ok = false; }
    document.body.removeChild(ta);
    return ok;
  }
  function copyCode() {
    var code = currentCode();
    if (code === 'ZPRIO') return;
    function done(ok) {
      if (!ok) { statusEl.textContent = 'Copy is not available. Your code is ' + code + '.'; return; }
      copyBtn.classList.add('is-done');
      copyLabel.textContent = 'Copied';
      statusEl.textContent = 'Code ' + code + ' copied';
      window.clearTimeout(state.copyTimer);
      state.copyTimer = window.setTimeout(resetCopy, 2000);
    }
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(code).then(function () { done(true); }, function () { done(legacyCopy(code)); });
    } else {
      done(legacyCopy(code));
    }
  }

  function loadCart() { return request('cart.js'); }
  function money(cents, currency) {
    try {
      return new Intl.NumberFormat(document.documentElement.lang || undefined, { style: 'currency', currency: currency }).format(cents / 100);
    } catch (e) {
      return (cents / 100).toFixed(2);
    }
  }
  function renderBag(cart) {
    var thumbs = bagEl.querySelector('[data-zo-thumbs]');
    thumbs.textContent = '';
    if (!cart || !cart.item_count) { bagEl.classList.remove('is-ready'); return; }
    var items = cart.items || [];
    for (var i = 0; i < items.length && i < 3; i++) {
      var src = (items[i].featured_image && items[i].featured_image.url) || items[i].image;
      if (!src) continue;
      var img = new Image();
      img.alt = '';
      img.decoding = 'async';
      img.width = 44;
      img.height = 54;
      img.src = src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=120';
      thumbs.appendChild(img);
    }
    var n = cart.item_count;
    bagEl.querySelector('[data-zo-bag-count]').textContent = n + (n === 1 ? ' piece in your cart' : ' pieces in your cart');
    bagEl.querySelector('[data-zo-bag-total]').textContent = 'Subtotal ' + money(cart.total_price, cart.currency);
    bagEl.classList.add('is-ready');
  }

  /* ---------------------------------------------------------------- open / close */
  function focusables() {
    return Array.prototype.filter.call(
      dialog.querySelectorAll('button:not([disabled]), input:not([disabled]), a[href]'),
      function (el) { return el.offsetParent !== null; }
    );
  }
  function onKeydown(e) {
    if (e.key === 'Escape' || e.key === 'Esc') { e.preventDefault(); dismiss(); return; }
    if (e.key !== 'Tab') return;
    var f = focusables();
    if (!f.length) { e.preventDefault(); return; }
    var first = f[0], last = f[f.length - 1], active = document.activeElement;
    if (e.shiftKey && (active === first || active === dialog)) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && active === last) { e.preventDefault(); first.focus(); }
  }

  function loadFont() {
    if (document.getElementById('zoq-offer-font')) return;
    var pre1 = document.createElement('link');
    pre1.rel = 'preconnect'; pre1.href = 'https://fonts.googleapis.com';
    var pre2 = document.createElement('link');
    pre2.rel = 'preconnect'; pre2.href = 'https://fonts.gstatic.com'; pre2.crossOrigin = 'anonymous';
    var css = document.createElement('link');
    css.id = 'zoq-offer-font'; css.rel = 'stylesheet';
    css.href = 'https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@400..700&display=swap';
    document.head.appendChild(pre1); document.head.appendChild(pre2); document.head.appendChild(css);
  }

  function openNow() {
    state.token++;                              // invalidates any cleanup still pending from an earlier close
    state.open = true;
    state.shown = true;
    state.lastFocus = document.activeElement;
    document.body.appendChild(root);            // last in the DOM so it wins ties against widget layers
    syncSelection(false);
    root.hidden = false;
    root.setAttribute('data-state', 'idle');
    document.documentElement.classList.add('zoq-offer-lock');
    var pg = pageEl(); if (pg) pg.setAttribute('inert', '');
    loadFont();
    void root.offsetWidth;                      // flush styles so the entrance transition runs
    root.setAttribute('data-state', 'open');
    document.addEventListener('keydown', onKeydown, true);
    window.setTimeout(function () { try { dialog.focus({ preventScroll: true }); } catch (e) { dialog.focus(); } }, 80);
  }

  function closeNow() {
    if (!state.open) return;
    state.open = false;
    document.removeEventListener('keydown', onKeydown, true);
    root.setAttribute('data-state', 'closing');
    document.documentElement.classList.remove('zoq-offer-lock');
    var pg = pageEl(); if (pg) pg.removeAttribute('inert');
    var back = state.lastFocus;
    if (back && back.focus && document.contains(back)) { try { back.focus({ preventScroll: true }); } catch (e) { /* ignore */ } }
    var token = ++state.token;
    var finished = false;
    function finish() {
      if (finished) return;
      finished = true;
      dialog.removeEventListener('transitionend', onEnd);
      if (token !== state.token) return;        // it was re-opened meanwhile - leave the new session alone
      root.hidden = true;
      root.setAttribute('data-state', 'idle');
      root.style.removeProperty('--zo-drag');
      state.claiming = false;
      root.classList.remove('is-claiming');
      claimBtn.disabled = false;
      Array.prototype.forEach.call(radios, function (r) { r.disabled = false; });
    }
    function onEnd(ev) { if (ev.target === dialog && ev.propertyName === 'transform') finish(); }
    dialog.addEventListener('transitionend', onEnd);
    window.setTimeout(finish, 900);
  }

  function holdFor(hours) { store.set(HOLD_KEY, String(Date.now() + hours * 3600 * 1000)); }
  function dismiss() {
    if (!state.open || state.claiming) return;
    holdFor(CONFIG.dismissHoldHours);
    closeNow();
  }

  function hasPaidItem(cart) {
    return !!cart && (cart.items || []).some(function (item) {
      return !(item.properties && item.properties._zoq_exit_gift === '1') && item.final_line_price > 0;
    });
  }
  function hasBusyDialog() {
    return Array.prototype.some.call(document.querySelectorAll(BUSY), function (el) {
      return !root.contains(el) && el.getAttribute('aria-hidden') !== 'true';
    });
  }
  function show(opts) {
    if (state.opening) return state.opening;
    if (state.open) return Promise.resolve(true);
    if (!(opts && opts.force) && (isHeld() || state.shown)) return Promise.resolve(false);
    state.opening = loadCart().then(function (cart) {
      if (!(opts && opts.force) && (!hasPaidItem(cart) || isHeld() || hasBusyDialog())) return false;
      if (window.getComputedStyle(root).position !== 'fixed') return false;
      state.cart = cart;
      renderBag(cart);
      openNow();
      if (state.cleanup) state.cleanup();
      return true;
    }).catch(function () { return false; }).finally(function () { state.opening = null; });
    return state.opening;
  }
  function giftLines(cart) {
    return (cart.items || []).filter(function (item) {
      return item.properties && item.properties._zoq_exit_gift === '1';
    });
  }
  function removeGiftLines(cart) {
    var updates = {};
    giftLines(cart).forEach(function (item) { updates[item.key] = 0; });
    return Object.keys(updates).length ? request('cart/update.js', { updates: updates }) : Promise.resolve(cart);
  }
  function addCareKit(cart) {
    var existing = (cart.items || []).find(function (item) {
      return Number(item.variant_id || item.id) === CONFIG.careKitVariantId;
    });
    var otherPaid = (cart.items || []).some(function (item) {
      return Number(item.variant_id || item.id) !== CONFIG.careKitVariantId && item.final_line_price > 0;
    });
    if (existing && otherPaid) return Promise.resolve(cart);
    return request('products/' + CONFIG.careKitHandle + '.js').then(function (product) {
      var variant = (product.variants || []).find(function (item) {
        return Number(item.id) === CONFIG.careKitVariantId && item.barcode === CONFIG.careKitBarcode && item.available;
      });
      if (!variant) throw new Error('kit_unavailable');
      return request('cart/add.js', { items: [{ id: variant.id, quantity: 1, properties: { _zoq_exit_gift: '1', _zoq_exit_offer: 'ZCARE' } }] });
    }).then(loadCart);
  }
  function accepted(cart, code) {
    if (cart.discount_codes) {
      var entry = cart.discount_codes.find(function (item) { return item.code.toUpperCase() === code; });
      if (entry && entry.applicable === false) return false;
    }
    if (code === 'ZSHIP') return true;
    var allocations = [];
    (cart.items || []).forEach(function (item) {
      if (code === 'ZCARE' && Number(item.variant_id || item.id) !== CONFIG.careKitVariantId) return;
      allocations = allocations.concat(item.line_level_discount_allocations || []);
    });
    if (code !== 'ZCARE') allocations = allocations.concat(cart.cart_level_discount_applications || []);
    var saving = allocations.reduce(function (total, allocation) {
      var application = allocation.discount_application || allocation;
      if (String(application.title || '').toUpperCase().indexOf(code) === -1) return total;
      return total + Number(allocation.amount || application.total_allocated_amount || 0);
    }, 0);
    if (code === 'ZCARE') {
      var prices = (cart.items || []).filter(function (item) {
        return Number(item.variant_id || item.id) === CONFIG.careKitVariantId;
      }).map(function (item) { return Number(item.original_price || item.price); });
      return prices.length > 0 && saving >= Math.min.apply(Math, prices) && saving > 0;
    }
    return saving > 0;
  }
  function rememberedCodes(cart) {
    var codes = (cart.discount_codes || []).map(function (item) { return item.code; });
    var allocations = cart.cart_level_discount_applications || [];
    (cart.items || []).forEach(function (item) { allocations = allocations.concat(item.line_level_discount_allocations || []); });
    allocations.forEach(function (allocation) {
      var application = allocation.discount_application || allocation;
      if (application.type === 'discount_code' && application.title) codes.push(application.title);
    });
    return codes.filter(function (code, i) { return codes.indexOf(code) === i; }).join(',');
  }
  function unlock() {
    state.claiming = false;
    root.classList.remove('is-claiming');
    claimBtn.disabled = false;
    Array.prototype.forEach.call(radios, function (radio) { radio.disabled = false; });
    setCta(current().getAttribute('data-cta'), false);
  }
  function claim() {
    if (state.claiming) return;
    state.claiming = true;
    errorEl.hidden = true;
    var code = currentCode();
    var before = null;
    var changed = false;
    root.classList.add('is-claiming');
    claimBtn.disabled = true;
    Array.prototype.forEach.call(radios, function (radio) { radio.disabled = true; });
    setCta(message('applying'), false);
    return loadCart().then(function (cart) {
      before = cart;
      if (!hasPaidItem(cart)) throw new Error('empty_cart');
      changed = true;
      return removeGiftLines(cart);
    }).then(function (cart) {
      return code === 'ZCARE' ? addCareKit(cart) : cart;
    }).then(function () {
      return request('cart/update.js', {
        discount: code === 'ZPRIO' ? '' : code,
        attributes: { 'Priority Crafting': code === 'ZPRIO' ? 'Yes' : '', 'ZOQ Exit Offer': code }
      });
    }).then(function (cart) {
      if (code !== 'ZPRIO' && !accepted(cart, code)) throw new Error('not_eligible');
      holdFor(CONFIG.claimHoldHours);
      api.navigate(CONFIG.cartUrl);
    }).catch(function (error) {
      var cleanup = changed ? loadCart().then(removeGiftLines).then(function () {
        return request('cart/update.js', { discount: rememberedCodes(before), attributes: {
          'Priority Crafting': (before.attributes || {})['Priority Crafting'] || '',
          'ZOQ Exit Offer': (before.attributes || {})['ZOQ Exit Offer'] || ''
        } });
      }) : Promise.resolve();
      return cleanup.then(function () {
        errorEl.textContent = message(error.message) || message('failed');
      }, function () {
        errorEl.textContent = message('cleanup_failed');
      }).finally(function () { errorEl.hidden = false; unlock(); });
    });
  }
  function isHeld() {
    var until = parseInt(store.get(HOLD_KEY) || '0', 10);
    return !!until && Date.now() < until;
  }
  function refreshEligibility() {
    if (state.claiming) return;
    if (state.refreshing) { state.refreshAgain = true; return state.refreshing; }
    state.refreshing = loadCart().then(function (cart) {
      if (!hasPaidItem(cart) && giftLines(cart).length) return removeGiftLines(cart).then(function (cleanCart) {
        if (window.location.pathname.replace(/\/$/, '') === CONFIG.cartUrl.replace(/\/$/, '')) {
          window.location.reload();
          return cleanCart;
        }
        // Tell the theme to redraw after our separate gift-removal request.
        // Otherwise its previous section HTML can still show a chargeable kit.
        import('@shopify/events').then(function (events) {
          document.dispatchEvent(new events.CartLinesUpdateEvent({
            action: 'remove', lines: [],
            promise: Promise.resolve({ cart: events.CartLinesUpdateEvent.createCartFromAjaxResponse(cleanCart) })
          }));
        }).catch(function () {});
        return cleanCart;
      });
      return cart;
    }).then(function (cart) {
      state.cart = cart;
      if (!hasPaidItem(cart)) {
        if (state.cleanup) state.cleanup();
        if (state.open) closeNow();
      } else if (!state.shown && !isHeld()) arm();
    }).catch(function () {}).finally(function () {
      state.refreshing = null;
      if (state.refreshAgain) { state.refreshAgain = false; refreshEligibility(); }
    });
    return state.refreshing;
  }
  function arm() {
    if (state.armed || state.shown || isHeld()) return;
    state.armed = true;
    var armedAt = Date.now();
    var timer, fontTimer, onLeave, vis, attempting = false;
    function disarm() {
      window.clearTimeout(timer);
      window.clearTimeout(fontTimer);
      if (onLeave) document.documentElement.removeEventListener('mouseleave', onLeave);
      if (vis) document.removeEventListener('visibilitychange', vis);
      state.armed = false;
    }
    function attempt() {
      if (attempting) return;
      window.clearTimeout(timer);
      if (state.open || state.shown || isHeld()) { disarm(); return; }
      if (document.visibilityState !== 'visible') return;
      if (hasBusyDialog()) { timer = window.setTimeout(attempt, 3000); return; }
      attempting = true;
      show().then(function (opened) {
        if (!opened && state.armed) timer = window.setTimeout(attempt, 3000);
      }).finally(function () { attempting = false; });
    }
    vis = function () { if (document.visibilityState === 'visible' && Date.now() - armedAt >= CONFIG.delayMs) attempt(); };
    document.addEventListener('visibilitychange', vis);
    timer = window.setTimeout(attempt, CONFIG.delayMs);
    fontTimer = window.setTimeout(loadFont, CONFIG.delayMs - 8000);
    if (CONFIG.exitIntent && window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
      onLeave = function (event) {
        if (event.clientY <= 12 && Date.now() - armedAt >= CONFIG.exitMinDwellMs) attempt();
      };
      document.documentElement.addEventListener('mouseleave', onLeave);
    }
    state.cleanup = disarm;
  }

  /* ---------------------------------------------------------------- mobile sheet: drag to dismiss */
  (function () {
    var grab = $('[data-zo-grab]');
    if (!grab || !window.PointerEvent) return;
    var startY = 0, dy = 0, t0 = 0, active = false;
    function isMobile() { return window.matchMedia('(max-width: 767px)').matches; }
    grab.addEventListener('pointerdown', function (e) {
      if (!isMobile()) return;
      active = true; startY = e.clientY; dy = 0; t0 = Date.now();
      try { grab.setPointerCapture(e.pointerId); } catch (err) { /* ignore */ }
      root.setAttribute('data-dragging', '');
    });
    grab.addEventListener('pointermove', function (e) {
      if (!active) return;
      dy = Math.max(0, e.clientY - startY);
      root.style.setProperty('--zo-drag', dy + 'px');
    });
    function end() {
      if (!active) return;
      active = false;
      root.removeAttribute('data-dragging');
      var velocity = dy / Math.max(1, Date.now() - t0);
      if (dy > 110 || velocity > 0.6) dismiss();
      else root.style.setProperty('--zo-drag', '0px');
    }
    grab.addEventListener('pointerup', end);
    grab.addEventListener('pointercancel', end);
  })();

  /* ---------------------------------------------------------------- wiring */
  root.addEventListener('click', function (e) {
    var t = e.target;
    if (t.closest('[data-zo-dismiss]')) { dismiss(); return; }
    if (t.closest('[data-zo-claim]')) { claim(); return; }
    if (t.closest('[data-zo-copy]')) { copyCode(); }
  });

  var api = {
    open: function () { return show({ force: true }); },
    close: dismiss,
    navigate: function (url) { window.location.assign(url); },
    config: CONFIG
  };
  window.zoqOffer = api;

  function boot() {
    var path = window.location.pathname;
    if (path.indexOf('/checkout') !== -1 || path.indexOf('/orders') !== -1) return;
    if (/[?&]zoq_offer=preview(&|$)/.test(window.location.search)) {
      window.setTimeout(function () { show({ force: true }); }, 700);
      return;
    }
    if (window.Shopify && window.Shopify.designMode) return;
    store.del('zoq_popup_end_time');
    document.addEventListener('shopify:cart:lines-update', function (event) {
      Promise.resolve(event.promise).then(refreshEligibility).catch(function () {});
    }, true);
    window.addEventListener('pageshow', refreshEligibility);
    window.addEventListener('storage', function (event) {
      if (event.key === HOLD_KEY && isHeld() && state.cleanup) state.cleanup();
    });
    refreshEligibility();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();

